export default "__VITE_ASSET__0kiIPCRs__"